<template>
  <div>
    <div class="info-widget" :style="{ backgroundColor, color }" @click="$emit('clicked')">
      <h3 v-text="title"></h3>
      <h4 v-text="stat" v-if="!animate"></h4>
      <h4 v-if="animate" class="animated bounceIn">
        <count-up
          :start="0"
          :end="stat"
          :decimals="0"
          :duration="2.5"
          :options="options"
        ></count-up>
      </h4>
      <div v-if="" class="info-widget-pic">
        <i v-if="showLogo" :class="logo"></i>
        <img v-if="showImage" :src="image"></i>
      </div>
    </div>
  </div>
</template>
<script>
  import CountUp from 'vue-countup-v2'
  export default {
    name: 'InfoWidget',
    data () {
      return {
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: ''
        }
      }
    },
    components: {
      CountUp
    },
    props: {
      backgroundColor: {
        type: String,
        required: true
      },
      color: {
        type: String,
        required: true
      },
      logo: {
        type: String,
        required: false
      },
      image: {
        type: String,
        required: false
      },
      stats: {
        type: Object,
        required: true
      },
      animate: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      showPic () {
        return this.logo || this.image
      },
      showImage () {
        return this.image && !this.logo
      },
      showLogo () {
        return this.logo
      },
      title () {
        return this.stats && this.stats.title ? this.stats.title : ''
      },
      stat () {
        return this.stats && this.stats.stat !== null && typeof this.stats.stat !== 'undefined' ? this.stats.stat : ''
      }
    }
  }
</script>
<style scoped>
  .info-widget {
    padding: 10px;
    position: relative;
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    transition: box-shadow 0.5s;
  }
  .info-widget-pic {
    position: absolute;
    top:0;
    left:0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .info-widget-pic i {
    margin-right: 10px !important;
    font-size: 50px;
  }
  .info-widget:hover {
    -webkit-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
  }
  i.fa {
    cursor: default !important;
  }
</style>



// WEBPACK FOOTER //
// InfoWidget.vue?ef5b6a60